
import React, {FC, MouseEvent, useState, useRef, useEffect, ChangeEvent, MutableRefObject}  from 'react';
import {useParams} from 'react-router';
import { useNavigate } from 'react-router-dom';
import { SnackbarAction, SnackbarKey, useSnackbar } from 'notistack';

import { debounce, sum } from 'lodash';

import { addMinutes } from 'date-fns';

import { Control, Controller, FieldArray, FieldArrayMethodProps, FormProvider, useFieldArray, useForm, UseFormGetValues, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { StringIfPlural, useTranslation  } from 'react-i18next';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';

import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import AddCircleIcon from '@mui/icons-material/AddCircle';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

import CopyAllIcon from '@mui/icons-material/CopyAll';

import CheckIcon from '@mui/icons-material/Check';

import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import DeleteIcon from '@mui/icons-material/Delete';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import PlaylistAddCircleIcon from '@mui/icons-material/PlaylistAddCircle';
import QueueIcon from '@mui/icons-material/Queue';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PersonAddAltIcon from '@mui/icons-material/PersonAddAlt';
import BuildCircleOutlinedIcon from '@mui/icons-material/BuildCircleOutlined';
import FactCheckOutlinedIcon from '@mui/icons-material/FactCheckOutlined';


import AssignmentIcon from '@mui/icons-material/Assignment';
import LocalMallIcon from '@mui/icons-material/LocalMall';
import SchoolIcon from '@mui/icons-material/School';
import DescriptionIcon from '@mui/icons-material/Description';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import RoomServiceIcon from '@mui/icons-material/RoomService';
import ArchiveIcon from '@mui/icons-material/Archive';

import FastfoodIcon from '@mui/icons-material/Fastfood';

import { MdOutlineAdd, MdOutlineCancel, MdOutlineCheckCircle } from 'react-icons/md';


import entityService, { useBasicFilterEntity } from 'features/services/Entity';
import { currentBasicTextFilterPropsAtom, currentFormNameAtom,currentUserSessionAtom, 
      isSearchBoxShowAtom, isSaveLoadingAtom, isWaitingBoxShowAtom } from 'library/store';
import useBillingService, { useBasicFilterBilling } from './services/Billing';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import { defaultFeatureDescription, IEntity, IFeatureDescription, IFeatureParameter, IResult } from 'library/interface';
import Button from '@mui/material/Button';
import { Checkbox, FormControlLabel, IconButton, InputAdornment, MenuItem, Tabs, Tab, Typography, Link, FormHelperText } from '@mui/material';
import NumberFormat from 'react-number-format';

import { IBilling, IBillingDelivery, IBillingDeliveryDetail, IBillingDetail, IBillingDetailInfo, 
        IBillingInfo, IBillingPackagingDetail, IBillingRentalResource, IBillingServiceTask, ICommissionDistribution, 
        defaultBilling, defaultBillingDelivery, defaultBillingDetail } from './models/Billing';


import TextFieldRight from 'components/ui/TextFieldRight';
import { FormDialog } from 'components/ui/FormDialog';
import { BasicTextFilterForm } from 'components/ui/BasicTextFilterForm';
import useEnumerationService, { useBasicFilterEnumeration, useEnumerationItemCreateUpdate } from 'features/configuration/services/Enumeration';


import IEnumeration,  { IEnumerationItem, Enum_SERVICE_TASK, Enum_OPERATION_STATUS, Enum_BILLING_STATUS_PURPOSE,
  Enum_ARTICLE_OPTION, Enum_ARTICLE_OPTION_CLASS, Enum_PRICE_PURPOSE, 
  Enum_MAINTENANCE_CATEGORY, Enum_CONTRACT_SCOPE, Enum_CONTRACT_TYPE, Enum_CORPORATION_TYPE, 
  Enum_RENTAL_PERIODICITY,
  Enum_CURRENCY, Enum_PAYMENT_SOURCE,
  Enum_CONSUMPTION_OPTION,
  Enum_BILLING_TERM_REFERENCE,
  defaultEnumerationItem} from 'features/configuration/models/Enumeration';

import useProductService, { useBasicFilterProduct, useBasicFilterProductWithOptions } from 'features/setup/services/Product';

import usePersonService, {useBasicFilterPerson, useBasicFilterPersonSearch}  from 'features/production/services/Person';

import { IProduct, IProductOption } from 'features/setup/models/Product';

import { carouselImage, justifyCenter, typographyGroupBoxStyling } from 'themes/commonStyles';

import EntityExpression from 'components/ui/EntityExpression';
import { isFalsy } from 'utility-types';
import ArrayFieldTableEx, { ActionIconTableRow, HeadCell } from 'components/ui/ArrayFieldTableEx';
import { DatePicker } from '@mui/x-date-pickers';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { IPerson, PersonType, defaultPerson } from 'features/production/models/Person';

import useUtils from 'library/utils';

import { useBasicFilterEmployee } from 'features/setup/services/Employee';
import { IEmployee } from 'features/setup/models/Employee';
import { IPackaging } from 'features/setup/models/Packaging';
import { useBasicFilterPackaging } from 'features/setup/services/Packaging';
import { GrClose, GrSearch } from 'react-icons/gr';
import EnhancedTable from 'components/ui/EnhancedTable';
import { NestCamWiredStandTwoTone } from '@mui/icons-material';
import ArrayField from 'components/ui/ArrayField';
import { title } from 'process';
import { DialogEnumerationItemForm } from 'features/configuration/DialogEnumerationItemForm';
import { defaultStore } from 'features/configuration';
import { IStore } from 'features/configuration/models/Store';



export interface BasicBillingInfoFormProps {
    
  control: Control<IBilling>,
  
  getValues: UseFormGetValues<IBilling>,
  setValue: UseFormSetValue<IBilling>,
  watch: UseFormWatch<IBilling>,
}

//type HasPersonPath<O extends FieldValues> = O extends { personPath: IPerson } ? BasicPersonFormProps<O> : never;




export function BasicBillingInfoForm 
({ setValue ,getValues, watch, control}: BasicBillingInfoFormProps) {

    const navigate = useNavigate();
    const { t, i18n } = useTranslation();  
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  
    const {id} = useParams();
  
    const {range, addDurationInPeriod} = useUtils();
  
    const {language: lg, taskCodes, userDescription, userName, 
        employeeId, roleEntities, applicationSetup, userStores} = useRecoilValue(currentUserSessionAtom);
    
    const [isWaitingBoxShow, setIsWaitingBoxShow] = useRecoilState(isWaitingBoxShowAtom);
  
    const [_id, _setId] = useState<number>( Number( id || 0 ) );
  
    const {retrieveEntity, retrieveData, openEntityActionDrawer, executeEntityFeature,
        checkEntityExpressionSyntax, checkEntitySaveAuthorization, openEntityPrintDrawer } = entityService();
  
      
    const { getProductOptionsByBilling } = useProductService();
  
    const { createBilling, updateBilling, evaluateAddedProduct, getCommissionDistributionsByBilling, deliverBillingDetail,
            createBillingDelivery, updateBillingDelivery, getBillingDeliveriesByBilling } = useBillingService();

  const {getEnumerationItemsByEnumerationCodes,getExtensionEnumerationItemsByProduct, getAsOptions } = useEnumerationService();
  
  const { createPerson, updatePerson, 
      getPersonsSearchCount, 
      getBirthDateType, getDateFormat, getDayFormat } = usePersonService();

  
  const [currentFormName, setCurrentFormNameAtom] = useRecoilState(currentFormNameAtom);
  const [isSaveLoading, setIsSaveLoading] = useRecoilState(isSaveLoadingAtom);


  const watchBillingDetailIndex = watch('currentBillingDetailIndex');
  const watchBusinessEmployeeId = watch('businessEmployeeId');  

  const watchDefaultPaymentSourceCode = watch('defaultPaymentSourceCode');
      
  const [openEntityFilter, setOpenEntityFilter] = useState(false);
  const basicFilterEntity = useBasicFilterEntity( 
      (event: React.MouseEvent<unknown>, row: IEntity) => {
          const {name, description} = row;

          // setValue('entityName', name || '');
          // setValue('entityDescription', description || '');
                           
          setOpenEntityFilter(false);
      }
  );

  const [openEnumerationFilter, setOpenEnumerationFilter] = useState(false);
  const basicFilterEnumeration = useBasicFilterEnumeration( 
      (event: React.MouseEvent<unknown>, row: IEnumeration) => {
          const {id, name, description} = row;

          // setValue('enumerationId', id);
          // setValue('enumerationName', name);
                           
          setOpenEnumerationFilter(false);
      }
  );

  

  const refFirstName = useRef<string>('');
  const refLastName = useRef<string>('');
  const refParticularSign = useRef<string>('');
  const refId = useRef<number>(getValues().id);
  
  
  const emptyFunc = (obj: any) => {}
  
  // const methods = useForm<IPerson>({defaultValues:defaultPerson});
  // const { register, setValue ,getValues, watch, reset ,handleSubmit ,control , formState: { errors } } = methods;

    
  type SearchPersonUsage = 'person' | 'father' | 'mother' | 'tutor';
  const [currentSearchPersonUsage, setCurrentSearchPersonUsage] = useState<SearchPersonUsage>('person');

  const [openPersonSearchFilter, setOpenPersonSearchFilter] = useState(false);
  const basicFilterPersonSearch = useBasicFilterPersonSearch( 
      () => {
        // const { firstName, lastName, particularSign,
        //         fatherFirstName, fatherLastName, fatherParticularSign,
        //         motherFirstName, motherLastName, motherParticularSign,
        //         tutorFirstName, tutorLastName, tutorParticularSign} = getValues();

        // const _firstName = (currentSearchPersonUsage === 'father') ? fatherFirstName :
        //             (currentSearchPersonUsage === 'mother') ? motherFirstName :
        //               (currentSearchPersonUsage === 'tutor') ? tutorFirstName : firstName;
        // const _lastName = (currentSearchPersonUsage === 'father') ? fatherLastName :
        //             (currentSearchPersonUsage === 'mother') ? motherLastName :
        //               (currentSearchPersonUsage === 'tutor') ? tutorLastName : lastName;
        // const _particularSign = (currentSearchPersonUsage === 'father') ? fatherParticularSign :
        //               (currentSearchPersonUsage === 'mother') ? motherParticularSign :
        //                 (currentSearchPersonUsage === 'tutor') ? tutorParticularSign : particularSign;

        return {firstName: refFirstName.current, lastName: refLastName.current, particularSign: refParticularSign.current};
        //return refPersonSearch.current || {firstName: '', lastName: '', particularSign: ''};
      },      
      (event: React.MouseEvent<unknown>, row: IPerson) => {
          const {id, firstName, lastName, birthDate, birthPlace, particularSign, email1, email2, corporationName, corporationType, creationDate,
              portable1, portable2, country, town, addressLine1, addressLine2} = row;
                               
        setOpenPersonSearchFilter(false);
      }
  );

  const {canAddEnumerationItem, canUpdateEnumerationItem, displayEnumerationItemDialog,
      enumerationItem, hideEnumerationItemDialog, saveEnumerationItem,
      onAddItemClick, onUpdateItemClick } = useEnumerationItemCreateUpdate();

  const [openPersonFilter, setOpenPersonFilter] = useState(false);
  const basicFilterPerson = useBasicFilterPerson( 
      (event: React.MouseEvent<unknown>, row: IPerson) => {
          const {id, type, firstName, lastName, birthDate, birthPlace, 
            particularSign, corporationName, corporationType, creationDate,
            portable1, portable2, email1, email2, country, town, addressLine1, addressLine2} = row;
                       
        setOpenPersonFilter(false);
      }
  );


    const {data: enumItems, refetch: refetchEnumerationItems} = useQuery<IEnumerationItem[]>( ['EnumerationItems', 'Billing'], () => getEnumerationItemsByEnumerationCodes
        ( [Enum_OPERATION_STATUS, Enum_BILLING_STATUS_PURPOSE, Enum_BILLING_TERM_REFERENCE,Enum_PAYMENT_SOURCE,
            Enum_PRICE_PURPOSE, Enum_CURRENCY, Enum_CORPORATION_TYPE ] ));
    
    const {data: enumItems2} = useQuery<IEnumerationItem[]>( ['EnumerationItems2', 'Billing'], () => getEnumerationItemsByEnumerationCodes
        ( [Enum_SERVICE_TASK, 
            Enum_ARTICLE_OPTION, Enum_ARTICLE_OPTION_CLASS, Enum_CONSUMPTION_OPTION,
            Enum_MAINTENANCE_CATEGORY, Enum_CONTRACT_SCOPE, Enum_CONTRACT_TYPE, Enum_RENTAL_PERIODICITY  ] ));

    type PersonUsage = 'customer' | 'billing-detail-service' | 'billing-packaging-service' | 'billing-detail-formation';
            
    const [currentPersonUsage, setCurrentPersonUsage] = useState<PersonUsage>('customer');
    const handleClickOpenPerson = async (event: any, usage: PersonUsage) => {
        setCurrentPersonUsage(usage);
        setOpenPersonFilter(true);
    }
         
    
    const cellEditableBillingInfo = (row: IBillingInfo, cellId: keyof IBillingInfo) => { 
      return true;
  }

  const [headBillingInfoCells, setHeadBillingInfoCells]  = useState<HeadCell<IBillingInfo>[]>([]);
  useEffect(() => {
    setHeadBillingInfoCells([   
      {id:'description', label : t('Description'),  display: true, type: 'string', width: 60, isEditable: cellEditableBillingInfo},   
      {id:'designation', label : t('Designation'),  display: true, type: 'string', width: 40, isEditable: cellEditableBillingInfo}, 
    ]);
  }, [t,i18n]);
      

  const refAppendBillingInfos = useRef<(value: Partial<FieldArray<IBilling>> | Partial<FieldArray<IBilling>>[], options?: FieldArrayMethodProps) => void>(null);
  const refUpdateBillingInfo = useRef<(index: number,value: Partial<FieldArray<IBilling>> ) => void>(null);
  const refRemoveBillingInfo = useRef<(index: number ) => void>(null);
  
  const billingInfoRowActionIcon = ( row: IBillingInfo) : ActionIconTableRow<IBilling,IBillingInfo> => {
      
    
    const res: ActionIconTableRow<IBilling,IBillingInfo> = {
      toolTip: 'viewDetails',
      icon: RemoveCircleIcon,
      hasAction: (getValues().status === '95'),  // ((optionPropertyName1 || '') !== '') || ((optionPropertyName2 || '') !== '') || ((optionPropertyName3 || '') !== ''),
      isActionExecuting: true,
      onRowClickIcon: (event : any,index: number, row: IBillingInfo) => {
        
        (refRemoveBillingInfo.current??emptyFunc)(index);                        
      }
    }
    return res;
}

const handleAddBillingInfos = (event: any) => {      
      if(getValues().proxy.billingInfos.some( x => isFalsy(x.description) && isFalsy(x.designation))) return;

      (refAppendBillingInfos.current??emptyFunc)({id: 0, billingId: 0, description: '', designation: '' });   
    }


   const refEnumItems = useRef<IEnumerationItem[]>();    
     useEffect( () => {   
         refEnumItems.current = enumItems;
       
     }, [enumItems]);
   
     const refEnumItems2 = useRef<IEnumerationItem[]>();    
     useEffect( () => {   
         refEnumItems2.current = enumItems2;
       
     }, [enumItems2]);

  const queryClient = useQueryClient();
  
    

   return (
    
            <Box sx={{ mt: 0.25, width: '100%' }}>
                <Grid container rowSpacing={0.5} columnSpacing={0.1}>
                    <Grid item xs={12} component={Paper} sx={{ borderRadius: 2, ml: 0, }} >
                      <Stack flexDirection='column'>
                          <Box sx={{ mt: 1, width: '100%' }} key={`billing reference  `}  >
                            <Controller name='defaultPaymentSourceCode' control={control}                                     
                              render={ ({field: {onChange, value}}) => (
                                <TextField select onChange={onChange} value={value} sx={{width:'calc(50% - 8px)'}} id="defaultPaymentSourceCode"
                                  label={`${t('Payment source')} - ${t('Default')}`} inputProps={ {readOnly: false}} 
                                  helperText={ 
                                    <FormHelperText>                                    
                                      { canAddEnumerationItem && <Link href="#" onClick={(event) => onAddItemClick(Enum_PAYMENT_SOURCE, 
                                                          t('Payment source'), t('Payment source'))}
                                        sx={{ cursor: 'pointer', textDecoration: 'none', color: 'blue', px: 3 }} >
                                        {t('Add')}
                                      </Link> }
                                      { (canUpdateEnumerationItem && !isFalsy(watchDefaultPaymentSourceCode) ) && <Link href="#" onClick={(event) => {
                                            onUpdateItemClick( Enum_PAYMENT_SOURCE, t('Payment source'), t('Payment source'),
                                              refEnumItems.current?.find(x => x.enumerationCode === Enum_PAYMENT_SOURCE && x.code === watchDefaultPaymentSourceCode))}}
                                        sx={{ cursor: 'pointer', textDecoration: 'none', color: 'blue' }} >
                                        {t('Update')}
                                      </Link> }
                                    </FormHelperText>
                                  }>
                                  {enumItems && enumItems.filter( e => 
                                        e.enumerationCode === Enum_PAYMENT_SOURCE ).map( 
                                    (x,idx) => <MenuItem key={x.code} value={x.code}>{x.name}</MenuItem> )
                                  }
                                </TextField>
                              )}
                            />
                            <Controller                   
                                key={`reference - :::`}                  
                                render={({ field }) => <TextField sx={{width:`calc(50% - 8px)`}} {...field} 
                                label={t('Reference')} inputProps={ {readOnly: false }}
                                    />}
                                name={`reference`}    
                                control={control}
                            />
                          </Box>
                          <Box sx={{ mt: 1, width: '100%' }} key={`billing designation  `}  >
                            <Controller                   
                                key={`designation - :::`}                  
                                render={({ field }) => <TextField sx={{width:`calc(100% - 8px)`}} {...field} 
                                label={t('Designation')} inputProps={ {readOnly: false }}
                                    />}
                                name={`designation`}    
                                control={control}
                            />
                          </Box>
                          <Box sx={{ mt: 1, width: '100%' }} key={`billing description  `}  >
                            <Controller                   
                                key={`description - ::`}                  
                                render={({ field }) => <TextField sx={{width:`calc(100% - 8px)`}} {...field} 
                                label={t('Description')} inputProps={ {readOnly: false }}
                                    />}
                                name={`description`}    
                                control={control}
                            />
                          </Box>
                          <Box sx={{ mt: 1, width: '100%' }} key={`details infos  `}  >
                            <ArrayFieldTableEx<IBilling,IBillingInfo,'id'> 
                              mainObject={getValues()} fieldKey='id' 
                              headCells={headBillingInfoCells} rowsPathName={`proxy.billingInfos`}
                              title={t('Informations')} rowActionIcon={billingInfoRowActionIcon}  
                              //onRowSelected={handleBillingDetailSelected}
                              //onRowDoubleClick={handleBillingDetailRowDoubleClick}
                                                  
                              refAppend={refAppendBillingInfos as MutableRefObject<(value: Partial<FieldArray<IBilling>> | Partial<FieldArray<IBilling>>[], options?: FieldArrayMethodProps) => void>}
                              refUpdate={refUpdateBillingInfo as MutableRefObject<(index: number,value: Partial<FieldArray<IBilling>>) => void>}
                              refRemove={refRemoveBillingInfo as MutableRefObject<(index: number) => void>}

                              //stateSelected={[selectedRoleEntities, setSelectedRoleEntities]}
                              //displayMore={undefined}
                              toolbarActions={                                
                                [
                                  { toolTip: `${t('Add')}...`, onClickIcon: handleAddBillingInfos ,icon: AddCircleIcon }, 
                                ]
                              } 
                              canCheckRow={false} //canFilterColumn={false} //canDisplayColumnHeader={false}
                            />
                          </Box>                                
                        </Stack>
                    </Grid>                   
                </Grid>
            </Box>        
  )
}

